import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";

/* Self-hosted fonts via Fontsource · KEIN externer Request an fonts.googleapis.com */
import "@fontsource-variable/fraunces";
import "@fontsource/jost/300.css";
import "@fontsource/jost/400.css";
import "@fontsource/jost/500.css";
import "@fontsource/jost/600.css";

import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// StrictMode temporär deaktiviert: Photo Sphere Viewer verträgt in v5 keine
// doppelte Effect-Invokation von React 19 StrictMode (Panorama-Load wird
// beim ersten Teardown abgebrochen und startet in einigen Fällen nicht neu).
root.render(
    <HelmetProvider>
        <App />
    </HelmetProvider>,
);
